import styled from 'styled-components';

/** The same grey trough the editor scrolls its page in, so the two views read as one surface. */
export const PreviewScroll = styled.div`
	flex: 1;
	min-height: 0;
	overflow: auto;
	background: #f1f3f5;
	padding: 6mm 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6mm;
`;

export const PreviewPage = styled.div`
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
	background: #ffffff;
	line-height: 0;
	// The stamp overlay is positioned against the page it belongs to, not the scroller.
	position: relative;
	// Confines the field highlight's multiply blend to this page's own canvas, whatever
	// stacking context happens to sit above the scroller.
	isolation: isolate;
`;
